import React from 'react';
import { useNavigate } from 'react-router-dom';
import truckImage from '../images/Truck.png';
import locationImage from '../images/location_on.png';
import organicImage from '../images/⸙.png';

export default function FincaHomepage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 via-green-100 to-green-700 flex flex-col">
      {/* Header */}
      <header className="px-6 py-8">
        <h1 className="text-2xl font-bold text-black">FINCA</h1>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-6 flex flex-col">
        {/* Hero Section */}
        <div className="mb-12">
          <p className="text-xl text-black mb-2">Fresh Produce,</p>
          <h2 className="text-5xl font-bold text-black mb-8">
            Grown With Care
          </h2>
          <button
            className="bg-black text-white px-8 py-4 rounded-full flex items-center gap-3 hover:bg-gray-800 transition-colors"
            onClick={() => navigate('/get-started')}
          >
            <span className="font-semibold">Get Started</span>
            <span>→</span>
          </button>
        </div>

        {/* Description Text */}
        <div className="mb-8 max-w-xs">
          <p className="text-black text-center leading-relaxed">
            We provide healthy, high-quality farm products straight from our fields to your home and business.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="flex flex-wrap gap-4 mb-12">
          {/* Deliver to you Card */}
          <div className="bg-white rounded-[20px] w-[165px] h-[149px] flex flex-col items-center justify-center shadow-lg">
            <div className="w-12 h-12 mb-3 bg-gray-200 rounded flex items-center justify-center">
              <img 
                src={truckImage} 
                alt="Delivery" 
                className="w-10 h-10"
              />
            </div>
            <p className="text-black font-semibold text-center">Deliver to you</p>
          </div>

          {/* 100% Organic Card */}
          <div className="bg-white rounded-[20px] w-[165px] h-[149px] flex flex-col items-center justify-center shadow-lg">
            <div className="w-12 h-12 mb-3 bg-gray-200 rounded flex items-center justify-center">
              <img 
                src={organicImage} 
                alt="Organic" 
                className="w-10 h-10"
              />
            </div>
            <p className="text-black font-semibold text-center">100% Organic</p>
          </div>

          {/* Local Card */}
          <div className="bg-white rounded-[20px] w-[165px] h-[149px] flex flex-col items-center justify-center shadow-lg">
            <div className="w-12 h-12 mb-3 bg-gray-200 rounded flex items-center justify-center">
              <img 
                src={locationImage} 
                alt="Local" 
                className="w-10 h-10"
              />
            </div>
            <p className="text-black font-semibold text-center">Local</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-6 text-center">
        <p className="text-white text-sm">
          Copyright © 2025 AADA. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
